// TelcoTrack — Plán vs skutečnost styling for materials Souhrn (mirrors finance-summary).

export const MATERIALS_SUMMARY_PLAN_HDR = 'bg-sky-100/90 dark:bg-sky-950/40 text-sky-900 dark:text-sky-100';
export const MATERIALS_SUMMARY_PLAN_HDR_START = `${MATERIALS_SUMMARY_PLAN_HDR} border-l-2 border-sky-300 dark:border-sky-600`;
export const MATERIALS_SUMMARY_PLAN_CELL = 'tabular-nums bg-sky-50/70 dark:bg-sky-950/25 text-sky-950 dark:text-sky-50';
export const MATERIALS_SUMMARY_PLAN_CELL_START = `${MATERIALS_SUMMARY_PLAN_CELL} border-l-2 border-sky-300 dark:border-sky-600`;

export const MATERIALS_SUMMARY_ACTUAL_HDR = 'bg-emerald-100/80 dark:bg-emerald-950/35 text-emerald-900 dark:text-emerald-100';
export const MATERIALS_SUMMARY_ACTUAL_HDR_START = `${MATERIALS_SUMMARY_ACTUAL_HDR} border-l-2 border-emerald-400 dark:border-emerald-600`;
export const MATERIALS_SUMMARY_ACTUAL_CELL = 'tabular-nums bg-emerald-50/60 dark:bg-emerald-950/20 text-emerald-950 dark:text-emerald-50';
export const MATERIALS_SUMMARY_ACTUAL_CELL_START = `${MATERIALS_SUMMARY_ACTUAL_CELL} border-l-2 border-emerald-400 dark:border-emerald-600`;

export const MATERIALS_SUMMARY_VARIANCE_HDR = '';
export const MATERIALS_SUMMARY_VARIANCE_CELL = 'tabular-nums font-medium';
